import React, { useRef, useState } from 'react';
import './video-player.scss';
import { LessonActionBtn } from '../action-buttons';

export interface VideoPlayerProps {
  url: string;
  onActionClick?: (isEligibleForReward: boolean) => void;
  onRewardEligibilityChange?: (isEligible: boolean) => void;
  rewardThreshold?: number; // 0-100
  disabled?: boolean;
}

export const VideoPlayer: React.FC<VideoPlayerProps> = ({ 
  url, 
  onActionClick, 
  onRewardEligibilityChange,
  rewardThreshold = 5, 
  disabled = false 
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [maxPercentWatched, setMaxPercentWatched] = useState(0);
  const [playbackSpeed, setPlaybackSpeed] = useState<number>(1);

  const toggleSpeed = () => {
    let newSpeed = 1;
    if (playbackSpeed === 1) newSpeed = 1.5;
    else if (playbackSpeed === 1.5) newSpeed = 2;
    else newSpeed = 1;
    
    setPlaybackSpeed(newSpeed);
    if (videoRef.current) {
      videoRef.current.playbackRate = newSpeed;
    }
  };

  const handleTimeUpdate = () => {
    if (videoRef.current) {
      const { currentTime, duration } = videoRef.current;
      if (duration > 0) {
        const watched = (currentTime / duration) * 100;
        if (watched > maxPercentWatched) {
          setMaxPercentWatched(watched);
          if (watched >= rewardThreshold) {
            onRewardEligibilityChange?.(true);
          }
        }
      }
    }
  };

  const handleActionClick = () => {
    if (videoRef.current) {
      videoRef.current.pause();
    }
    const isEligibleForReward = maxPercentWatched >= rewardThreshold;
    onActionClick?.(isEligibleForReward);
  };

  return (
    <>
      <div className="v2-video-player">
        <video
          ref={videoRef}
          src={url}
          controls
          className="v2-video-player__media"
          onPlay={() => setIsPlaying(true)}
          onPause={() => setIsPlaying(false)}
          onTimeUpdate={handleTimeUpdate}
          controlsList="nodownload"
        >
          Your browser does not support the video tag.
        </video>
        <button
          className="v2-video-player__speed-btn"
          onClick={toggleSpeed}
          title={`Speed: ${playbackSpeed}x`}
          aria-label={`Current speed ${playbackSpeed}x. Click to change speed`}
        >
          {playbackSpeed}x
        </button>
      </div>
      {onActionClick && (
        <div className="v2-play-lesson-video__btn">
          <LessonActionBtn onClick={handleActionClick} disabled={disabled} />
        </div>
      )}
    </>
  );
};

export default VideoPlayer;
